import React from "react";
import "./HomePage.css";
import ContextSection from "./ContextSection";
import Header from "./Header";
import HiringSection from "./HiringSection";
import Jobs from "./Jobs";
import ScrollFadeSection from "./ScrollFadeSection";

const HomePage = () => {
  return (
    <div className="cafe-homepage">
      <Header />
      <ScrollFadeSection />
      <HiringSection />
      <ContextSection />
      <Jobs />
    </div>
  );
};

export default HomePage;
